import AgentDetail from './AgentDetail';

export default AgentDetail;
